<template>
  <div class="row-wrapper">
    <div class="score-wrapper">
      <img v-if="!data.topRated" src="@/modules/lenders/assets/top_rated_badge.png" />
      <h3 v-if="$vuetify.breakpoint.lgAndUp">{{ score }}</h3>
    </div>

    <ScoreBar :score="score" />

    <h5>{{ data.category }}</h5>
  </div>
</template>

<script>
import ScoreBar from './ScoreBar'

export default {
  name: 'LenderScoreTableRow',
  components: {
    ScoreBar,
  },
  props: {
    data: Object,
  },
  computed: {
    score () {
      return (this.data && Math.round(this.data.score)) || 0
    },
  },
}
</script>

<style lang="scss" scoped>
.row-wrapper {
  width: 100%;
  height: 100%;
  padding: 10px 20px;

  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr auto auto;
  grid-template-rows: auto;
  grid-column-gap: 10px;
  align-items: center;

  text-align: center;

  @include lg {
    padding: 10px 0;

    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, auto);
  }
}

.score-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  @include mdAndBelow {
    @include gridPos($colS: 3, $colE: 4);
  }
}

.score-bar-wrapper {
  @include mdAndBelow {
    @include gridPos($colS: 2, $colE: 3);
  }
}

h3 {
  color: $primaryBlue;
  font-size: 32px;
}

h5 {
  @include mdAndBelow {
    font-family: "Sansation Regular", sans-serif;
    font-weight: normal;

    @include gridPos($colS: 1, $colE: 2);
  }
}

img {
  margin-left: 20px;
  order: 1;

  height: 40px;
  width: 40px;

  & + h3 { margin-left: 60px; }
}
</style>
